/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Label_ApproverInputs */

const vi_sl_detail_label_approver = /** @type {(inputs: Sl_Detail_Label_ApproverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người duyệt`)
};

/**

* @param {Sl_Detail_Label_ApproverInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_label_approver = /** @type {((inputs?: Sl_Detail_Label_ApproverInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Label_ApproverInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_label_approver(inputs)
});